/* CUSTOM: Digital Product Passport (Carbonfact) — lazy iframe embed in the "Origin" accordion; sets the iframe src on first open and swaps the passport id on variant change.
   Loaded PDP-only from layout/theme.liquid; markup from snippets/custom-product-accordion-impact.liquid, whose data-dpp-map carries every variant's passport id. */
(() => {
  if (window.__customDppInit) return;
  window.__customDppInit = true;

  const EMBED_SELECTOR = '.custom-dpp-embed';

  const passportId = (embed) => {
    let map;
    try {
      map = JSON.parse(embed.getAttribute('data-dpp-map') || '{}');
    } catch {
      return null;
    }
    return map[embed.getAttribute('data-dpp-variant')] || null;
  };

  const srcFor = (embed) => {
    const id = passportId(embed);
    if (!id) return null;
    const base = embed.getAttribute('data-dpp-base');
    if (!base) return null;
    const lang = embed.getAttribute('data-dpp-lang') || 'en';
    return `${base}${encodeURIComponent(id)}?embed=true&lang=${encodeURIComponent(lang)}`;
  };

  // Without an accordion (embed placed freely in the content) the embed counts as visible.
  const isVisible = (embed) => {
    const details = embed.closest('details');
    return !details || details.open;
  };

  const load = (embed) => {
    const iframe = embed.querySelector('iframe');
    if (!iframe || !isVisible(embed)) return;
    const src = srcFor(embed);
    if (src && iframe.getAttribute('src') !== src) iframe.setAttribute('src', src);
  };

  const loadAll = (root = document) => root.querySelectorAll(EMBED_SELECTOR).forEach(load);

  // Accordion already open in the server-rendered markup.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadAll());
  } else {
    loadAll();
  }

  // Accordion opened — "toggle" does not bubble, hence the capture-phase listener on document.
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (details instanceof Element && details.matches('details')) loadAll(details);
    },
    true
  );

  // Variant change: the accordion block is not on the partial-rerender list, so the passport id is swapped here.
  // Only the main product form counts — quick-buy modals hang off <body> and must not drive the embed.
  document.addEventListener('variant:change', (event) => {
    const variantId = event.detail?.variant?.id;
    if (!variantId) return;

    const target = event.target;
    const formId = target instanceof Element ? target.getAttribute('id') || '' : '';
    if (!formId.startsWith('product-form-main-')) return;

    document.querySelectorAll(EMBED_SELECTOR).forEach((embed) => {
      embed.setAttribute('data-dpp-variant', String(variantId));
      const iframe = embed.querySelector('iframe');
      if (!iframe) return;

      if (isVisible(embed)) {
        load(embed);
      } else if (iframe.hasAttribute('src')) {
        iframe.removeAttribute('src');
      }
    });
  });
})();
